module.exports = __webpack_public_path__ + "img/img9.f474e3df.svg";